import { Fragment } from 'react';
import { Button } from '@packages/ui/primitives/Button';
import { Inline } from '@packages/ui/layout';
import { rem } from '@packages/ui/tokens';
import type { ResolvedWizardButtons } from '../types';

export interface WizardButtonBarProps {
  buttons: ResolvedWizardButtons;
  onNext(): void;
  onBack(): void;
  onCancel(): void;
  onSecondaryClick(buttonId: string): void;
}

export function WizardButtonBar({
  buttons,
  onNext,
  onBack,
  onCancel,
  onSecondaryClick,
}: WizardButtonBarProps): JSX.Element {
  return (
    <Inline gap={rem(12)} justify='end'>
      {!buttons.back.hidden && (
        <Button
          variant='secondary'
          label={buttons.back.label}
          onClick={onBack}
          disabled={buttons.back.disabled}
        />
      )}

      {buttons.secondary.map((btn) =>
        btn.visible ? (
          <Fragment key={btn.id}>
            <Button
              variant={btn.variant as 'secondary' | 'secondary-gray'}
              label={btn.label}
              onClick={() => onSecondaryClick(btn.id)}
              disabled={btn.disabled}
              loading={btn.loading}
            />
          </Fragment>
        ) : null,
      )}

      {!buttons.cancel.hidden && (
        <Button
          variant='secondary-gray'
          label={buttons.cancel.label}
          onClick={onCancel}
          disabled={buttons.cancel.disabled}
        />
      )}

      {!buttons.primary.hidden && (
        <Button
          variant='primary'
          label={buttons.primary.label}
          onClick={onNext}
          disabled={buttons.primary.disabled}
          loading={buttons.primary.loading}
        />
      )}
    </Inline>
  );
}
